import axios from 'axios';
import { API_CORE_URL, API_URL } from "../constantes/constantes";

/**
 * Obtiene la lista de eventos/partidos futuros de una liga
 * @returns {Promise<Object>} Objeto con lista de eventos y código de estado
 */

export async function getEvents() {
  let type1 = "9zum4nxferygj8bb0ldcavxn8"; //id liga-mx
  let country = "mx";
  let timezone = "America/Mexico_City";
  let fase = "apertura";

  try {
    const url = `${API_CORE_URL}events/tournament/${type1}/matchdays`

    const { data, status } = await axios.get(url, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
      params: {
        ...(country === 'us' && { country }),
        ...(timezone && { timezone }),
        ...(fase && { fase })
      },
    });

    // Extraer array de partidos de la respuesta
    // El endpoint /matchday devuelve un objeto, no un array directo
    let events = [];

    if (Array.isArray(data)) {
      // Si es un array, usarlo directamente
      events = data;
    } else if (data && typeof data === 'object') {
      // Si es un objeto, buscar el array de partidos (puede estar en diferentes propiedades)
      events = data || [];
    }
    const responseData = events;

    return { statusCode: status, data: responseData };
  } catch (error) {
    console.error('Error en la petición:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}